<template>
	<div class="m-layout" :style="{'border-top': !showTopBar ? 'none' : ''}">
		<MobileMenu :isOpen="menuOpen" @close="closeMenu" @search="showSearch" />
		<transition name="m-slide-up">
			<div v-if="searchOpen" class="m-search-drawer">
				<div class="m-search-mask" @click="closeSearch" @touchmove.prevent></div>
				<div class="m-search-sheet">
					<MobileSearch @close="closeSearch" @back="closeSearch" />
				</div>
			</div>
		</transition>

		<main class="m-content">
			<slot />
		</main>

		<div class="m-bottom-bar" v-if="!hideBottomBar">
			<div class="m-bottom-bar-icons">
				<button class="m-icon-btn" @click="showSearch">
					<img :src="searchIcon" alt="search" />
				</button>
				<button class="m-icon-btn" @click="goEnquiry">
					<img :src="bagIcon" alt="bag" />
				</button>
			</div>

			<button class="m-menu-trigger" @click="openMenu" style="font-family: 'Bespoke Serif', serif;">Menu</button>

			<div class="m-bottom-bar-icons" style="justify-content: flex-end;">
				<button class="m-icon-btn" @click="openEmail">
					<img :src="miniLogo" alt="logo" />
				</button>
				<button class="m-icon-btn" @click="goAccount">
					<img :src="userIcon" alt="user" />
				</button>
			</div>

		</div>

		<!-- <MobileEmail ref="emailPopup" :open="emailOpen" @close="emailOpen = false" /> -->
		<MobileEmail :visible.sync="emailOpen" :auto-show-delay="0" @close="onEmailClose" />
	</div>
</template>

<script>
	import MobileMenu from './Menu.vue'
	import MobileSearch from './search.vue'
	const searchIcon = require('@/assets/mobile/icon/search.png')
	const bagIcon = require('@/assets/mobile/icon/product.png')
	const userIcon = require('@/assets/mobile/icon/user.png')
	const miniLogo = require('@/assets/mobile/icon/miniLogo.png')
	import MobileEmail from './email.vue'

	export default {
		name: 'MobileLayout',
		components: {
			MobileMenu,
			MobileSearch,
			MobileEmail
		},
		props: {
			showTopBar: {
				type: Boolean,
				default: true
			},
			hideBottomBar: {
			      type: Boolean,
			      default: false
			    }
		},
		data() {
			return {
				menuOpen: false,
				searchOpen: false,
				searchIcon,
				bagIcon,
				userIcon,
				miniLogo,
				emailOpen: false,
			}
		},
		mounted() {
			window.addEventListener('open-auto-email-popup', this.handleAutoEmailPopup)
		},
		beforeDestroy() {
			window.removeEventListener('open-auto-email-popup', this.handleAutoEmailPopup)
		},
		methods: {
			handleAutoEmailPopup() {
				this.emailOpen = true
			},
			// 供父组件调用：打开订阅弹窗
			openEmailPopup(isAuto = false) {
				// 自动弹出时，若已订阅或已记录则不弹；此判断已在父组件完成，此处可简单打开
				this.emailOpen = true
			},

			// 弹窗关闭时的回调
			onEmailClose() {
				// 记录永久标记，下次不再自动弹出
				localStorage.setItem('emailAutoShown', 'true')
				this.emailOpen = false
			},

			openMenu() {
				this.menuOpen = true
			},
			closeMenu() {
				this.menuOpen = false
			},
			goProduct() {
				if (this.$route.path !== '/m/product') {
					this.$router.push('/m/product')
				}
			},
			showSearch() {
				this.menuOpen = false
				this.searchOpen = true
			},
			closeSearch() {
				this.searchOpen = false
			},
			openEmail() {
				this.emailOpen = true
			},
			goAccount() {
				if (this.$route.path !== '/m/account') {
					this.$router.push('/m/account')
				}
			},
			goEnquiry() {
				if (this.$route.path !== '/m/enquiry') {
					this.$router.push('/m/enquiry')
				}
			},
			showAccount() {
				window.dispatchEvent(new CustomEvent('app-message', {
					detail: {
						type: 'info',
						title: 'Account',
						message: 'Account is coming soon.'
					}
				}))
			}
		}
	}
</script>

<style scoped>
	.m-layout {
		min-height: 100vh;
		width: 100%;
		overflow-x: hidden;
		background: #ffffff;
		color: #000;
		display: flex;
		flex-direction: column;
		/* border-top: 1rem solid #000; */
	}



	.m-content {
		flex: 1;
		/* 增加底部内边距，防止内容被底部导航栏遮挡 */
		/* safe-area-inset-bottom 确保内容避开 iPhone X+ 的底部 Home 指示条 */
		padding-bottom: calc(45rem + constant(safe-area-inset-bottom));
		/* 兼容 iOS 11.0 */
		padding-bottom: calc(45rem + env(safe-area-inset-bottom));
		/* 兼容 iOS 11.2+ */
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	.m-bottom-bar {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		height: 45rem;
		background: #fff;
		border-top: 1rem solid #000;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 28rem;
		/* 适配底部安全区域，避免被 Home 指示条遮挡 */
		padding-bottom: constant(safe-area-inset-bottom);
		/* 兼容 iOS 11.0 */
		padding-bottom: env(safe-area-inset-bottom);
		/* 兼容 iOS 11.2+ */
		box-sizing: content-box;
		/* 确保 padding 不会影响设定的 height */
		z-index: 20;
	}

	.m-bottom-bar-icons {
		display: flex;
		gap: 20rem;
		width: 40%;
	}

	.m-icon-btn {
		background: none;
		border: none;
		padding: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.m-icon-btn img {
		width: 18rem;
		height: 18rem;
	}

	.m-menu-trigger {
		background: none;
		border: none;
		font-size: 13rem;
		/* font-weight: 600; */
		color: #000;
	}

	.m-spacer {
		width: 18rem;
		height: 18rem;
	}

	.m-fade-enter-active,
	.m-fade-leave-active {
		transition: opacity 0.2s ease;
	}

	.m-fade-enter,
	.m-fade-leave-to {
		opacity: 0;
	}

	.m-search-drawer {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		height: 100vh;
		/* 抽屉层占满视口，彻底覆盖底部页面 */
		z-index: 9999 !important;
		display: flex;
		align-items: flex-start !important;
		/* 搜索面板从顶部开始布局 */
		overflow: hidden;
		/* 阻断抽屉容器自身滚动，避免滚动链路外泄 */
		overscroll-behavior: contain;
		/* 阻止滚动传递到页面根节点 */
	}

	.m-search-mask {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.35);
		cursor: pointer;
		pointer-events: auto;
		/* 恢复事件接收，允许点击关闭 */
		z-index: 0;
	}

	.m-search-sheet {
		position: relative;
		width: 100%;
		height: calc(100vh - 45rem);
		/* 扣除底部栏高度，给内部列表提供确定滚动高度 */
		max-height: calc(100vh - 45rem);
		/* 兜底限制高度，避免超出视口 */
		display: flex;
		flex-direction: column;
		overflow: hidden;
		/* 由内部内容区承担滚动，避免双滚动容器冲突 */
		align-self: flex-start;
		pointer-events: auto;
		z-index: 1;
		touch-action: pan-y;
		/* 明确允许纵向手势给内容区滚动 */
	}

	.m-slide-up-enter-active,
	.m-slide-up-leave-active {
		transition: opacity 0.3s;
	}

	.m-slide-up-enter-active .m-search-mask,
	.m-slide-up-leave-active .m-search-mask {
		transition: opacity 0.3s;
	}

	.m-slide-up-enter-active .m-search-sheet,
	.m-slide-up-leave-active .m-search-sheet {
		transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
	}

	.m-slide-up-enter,
	.m-slide-up-leave-to {
		opacity: 1;
	}

	.m-slide-up-enter .m-search-mask,
	.m-slide-up-leave-to .m-search-mask {
		opacity: 0;
	}

	.m-slide-up-enter .m-search-sheet,
	.m-slide-up-leave-to .m-search-sheet {
		transform: translateY(-100%);
	}
</style>